import { action } from 'satcheljs';

/**
 * Action to initialize the automatic replies view state
 */
const initializeAutomaticRepliesViewState = action('initializeAutomaticRepliesViewState');

export default initializeAutomaticRepliesViewState;
